var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 231 231",
    style: {
      enableBackground: "new 0 0 231 231"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.3,106.8l-11.2-25.3c-1.2-2.7-3.9-4.5-6.9-4.5h-18.5c-4.1,0-7.5,3.4-7.5,7.5v11.8h-5.8v-9.7c0-4.1-3.4-7.5-7.5-7.5h-20 V58.7c0-4.1-3.4-7.5-7.5-7.5h-36.9V44h36.9c4.1,0,7.5-3.4,7.5-7.5c0-4.1-3.4-7.5-7.5-7.5H56.8c-4.1,0-7.5,3.4-7.5,7.5 c0,4.1,3.4,7.5,7.5,7.5h36.9v7.1H56.8c-4.1,0-7.5,3.4-7.5,7.5v6.2H32.8c-4.1,0-7.5,3.4-7.5,7.5v40.2H15V72.4c0-4.1-3.4-7.5-7.5-7.5 S0,68.3,0,72.4v95.5c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-40.2h10.3v40.2c0,4.1,3.4,7.5,7.5,7.5h29.1l29.6,24.8 c1.3,1.1,3.1,1.7,4.8,1.7H173c4.1,0,7.5-3.4,7.5-7.5V174h5.8v11.8c0,4.1,3.4,7.5,7.5,7.5h18.5c3,0,5.7-1.8,6.9-4.5l11.2-25.3 c0.4-1,0.6-2,0.6-3v-50.6C231,108.8,230.8,107.8,230.3,106.8z M216,158.9l-8.6,19.4h-6.1v-11.8c0-4.1-3.4-7.5-7.5-7.5H173 c-4.1,0-7.5,3.4-7.5,7.5v20.4H99.1l-29.6-24.8c-1.3-1.1-3.1-1.7-4.8-1.7H40.3V79.9h16.5c4.1,0,7.5-3.4,7.5-7.5v-6.2H138v20.5 c0,4.1,3.4,7.5,7.5,7.5h20v9.7c0,4.1,3.4,7.5,7.5,7.5h20.8c4.1,0,7.5-3.4,7.5-7.5V92.1h6.1l8.6,19.4V158.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdling);
export default __webpack_public_path__ + "static/media/idling.92c557dc18a2257e82d053f72aec68e5.svg";
export { ForwardRef as ReactComponent };